export const Title = ({ title }: { title: string }) => {
    return (
        <p className="text-[36px] md:text-[44px] lg:text-[52px] xl:text-[60px] text-black-pro text-center lg:text-start leading-[110%] font-helvetica-bold">
            {title}
        </p>
    );
};
